import React from "react";
import img1 from "../assets/auction.jpg";
import img2 from "../assets/news1.jpg";
import { Carousel } from "antd";
const ProjectDetalis = () => {
    return (
        <>
            <div className="flex flex-col items-center  pb-24">
                <div className="w-9/12   rounded-xl overflow-hidden px-4 ">
                    <div className="flex flex-wrap  flex-col p-2  py-8 self-center md:self-start">
                        <h1 className="font-semibold text-3xl md:text-4xl  text-purple mt-14 w-full">
                            عنوان الفعالية
                        </h1>
                        <h3 className="font-medium text-xl md:text-2xl  text-slate-600  w-full">
                            25 اكتوبر 2023
                        </h3>
                    </div>
                    <Carousel autoplay>
                        <div className="carousal-img bg-black min-h-[350px]">
                            <img
                                src={img1}
                                className="rounded-xl min-h-[350px]"
                                alt="hag"
                            />
                        </div>
                        <div className="carousal-img bg-black min-h-[350px]">
                            <img
                                src={img2}
                                className="rounded-xl min-h-[350px]"
                                alt="hag"
                            />
                        </div>
                        <div className="carousal-img bg-black min-h-[350px]">
                            <img
                                src={img1}
                                className="rounded-xl min-h-[350px]"
                                alt="hag"
                            />
                        </div>
                    </Carousel>
                </div>
                <div className="text-right px-4  max-w-prose sm:max-w-4xl">
                    <h4 className="font-medium text-lg md:text-2xl self-start  mt-14 text-slate-600  ">
                        اهتمت رؤية المملكة العربية السعودية 2030 بقطاع الأعمال؛
                        حيث كان من محاورها الرئيسية؛ تبني اقتصادا مزدهرا ينعم
                        فيه الجميع بفرص متعددة للنجاح، عبر توفير بيئة عمل داعمة
                        للشركات الصغيرة والمتوسطة والكبيرة، والاستثمار في
                        التعليم استعدادا لوظائف المستقبل، لتوفير مستقبل زاخر
                        للجميع على أرض المملكة.
                    </h4>
                    <h4 className="font-medium text-lg md:text-2xl self-start  mt-14 text-slate-600  ">
                        ومن هذا المنطلق يطيب لي أن أقدم بفخر واعتزاز شركة
                        "أرسيليا"؛ وهي شركة سعودية تأسست عام 0000؛ وهي من
                        المجموعات الاستثمارية الرائدة التي تركز على رؤية
                        المستقبل؛ وتنشط في قطاع الأعمال بالمملكة العربية
                        السعودية؛ تتكون مجموعة "أرسيليا" من عدة شركات ذات أنشطة
                        متعددة؛ وتنضوي تحتها مجموعة شركات وأسماء أعمال مختلفة في
                        أنشطتها.
                    </h4>
                </div>
            </div>
        </>
    );
};

export default ProjectDetalis;
